import SdkFlowDefinitionCard from "@/components/sdk-flow-definition-card/sdk-flow-definition-card.vue";
import { PropType, defineComponent } from "vue";

export default defineComponent({
  name: "sdk-flow-search-result",
  components: {
    SdkFlowDefinitionCard,
  },
  props: {
    list: {
      type: Array as PropType<any[]>,
      required: true,
    },
  },
  data() {
    return {
      listCategory: [] as string[],
      finalList: [] as any[],
    };
  },
  watch: {
    list: "watchListChange",
  },
  methods: {
    watchListChange() {
      this.listCategory = this.list.map((item: any) => item.category.name);
      const newArray = this.listCategory.filter((item, i) => this.listCategory.indexOf(item) === i);
      this.listCategory = newArray;
      this.finalList = this.listCategory.map((item) => {
        const catList = this.list.filter((card: any) => card.category.name === item);
        return { category: item, list: catList };
      });
    },
  },
  mounted() {
    this.watchListChange();
  },
});
